<template>
    <div @click="emitDirections"
         :class="{'heavy-border': scaledSentiment}"
         style="cursor: pointer"
    >
        <div class="message" v-html="message"></div>

        <div class="footer-text-container">
            <div class="footer-text">For: {{data.source}}</div>
            <div class="footer-text">On: {{time}}</div>
            <div class="footer-text">ID: {{data.id}}</div>
            <div class="footer-text">Overall Sat: {{convertSat(data.sat)}}</div>
            <div class="footer-text">Driver Sat: {{convertSat(data.driver_sat)}}</div>
            <div class="footer-text">Sentiment Score: {{data.colorScaleValue}}</div>
<!--            <div class="footer-text">Auto Reroute: {{ (data.reroute) ? "Yes" : 'No'}}</div>-->
            <div class="footer-text">Channel: {{ data.channel }}</div>

        </div>
    </div>
</template>

<script>

    import Moment from "moment";
    import AppealsForm from "../dashboard/AppealsForm";
    var Rainbow = require('rainbowvis.js');
    import * as d3 from 'd3';

	export default {
        name: "Comment",
        props: ['data', 'search_words'],
        components: {AppealsForm},
        methods: {
            emitDirections: function(){
                this.$emit('singleSurvey', {
                    sc_dt: this.data.time,
                    sc_id: this.data.id,
                    active: true,
                })
            },
            convertSat: function(satNumber) {
                let converter = {
                    1: 'Totally Satisfied',
                    2: 'Satisfied',
                    3: 'Neither',
                    4: 'Dissatisfied',
                    5: 'Totally Dissatisfied',
                    6: "Cant say"
                }
                if (satNumber){
                    return converter[satNumber]
                }

            }

        },
        computed: {
            time: function() {
                return Moment.utc(this.data.time).format('MMMM DD, YYYY')
            },
            scaledSentiment: function() {
                let val = this.data.colorScaleValue
                var myRainbow  = new Rainbow()
                myRainbow.setSpectrum('red', 'yellow', 'green')
                if (val==0.5) {
                    return "#D3D3D3"
                } else {
                return '#' + myRainbow.colourAt(val*100)
                }
            },

            message: function() {
                let this_message = this.data.message;
                let regexp = /(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}/g
                this_message = this_message.replace(regexp, '***-***-****')

                function makeBold(input, wordsToBold) {
                    let plural_words = wordsToBold.map(function(el) { return el + 's'})
                    console.log(plural_words)

                    wordsToBold = wordsToBold.concat(plural_words)

                    return input.replace(new RegExp('()(' + wordsToBold.join('|') + ')()', 'ig'), '<mark style="background-color:black; color:gold;">$2</mark>');
                }

                if (this.search_words){
                    this_message = makeBold(this_message, this.search_words[0])
                }
                return '<p>' + this_message + '</p>'
            }
        }
    }
</script>

<style lang="less" scoped>

    @import "../../assets/less/theme.less";

    .comment {
        margin: 10px;
        padding: 5px;
        cursor: pointer;
    }

    .for-line {
        margin: 2px !important;
    }

    .footer-text-container {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: .8;
        /*color: black !important;*/

        .footer-text {
            margin: 0 2em;
        }
    }



    .heavy-border {
        border-width: 0 !important;
        border-color: black !important;
        border-style: none !important;
    }

    .message {
        margin: 1.5em;
        font-size: 18px;
        text-align: left;
        background: none;
        /*color: black !important;*/
    }

    .card-faded-primary {
        background-color: rgba(@primary, .8);
    }

    b {
        background-color: yellow;
    }

           @media only screen and (max-width: 600px) {
  .footer-text-container {
      flex-direction: column;
  }
               .message {
                   text-align:center;
               }
               .comment {
                   margin: 0;
                   margin-top: 10px;
               }
}

</style>
